var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666748 1.50008C0.666748 1.03984 1.03984 0.666748 1.50008 0.666748H8.99662C9.45686 0.666748 9.82996 1.03984 9.82996 1.50008C9.82996 1.96032 9.45686 2.33341 8.99662 2.33341H2.33341V15.6667H9.00008C9.46032 15.6667 9.83341 16.0398 9.83341 16.5001C9.83341 16.9603 9.46032 17.3334 9.00008 17.3334H1.50008C1.03984 17.3334 0.666748 16.9603 0.666748 16.5001V1.50008Z",
    fill: "#141415"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1608 4.66083C12.4863 4.33539 13.0139 4.33539 13.3393 4.66083L17.0893 8.41083C17.4148 8.73626 17.4148 9.2639 17.0893 9.58934L13.3393 13.3393C13.0139 13.6648 12.4863 13.6648 12.1608 13.3393C11.8354 13.0139 11.8354 12.4863 12.1608 12.1608L15.3216 9.00008L12.1608 5.83934C11.8354 5.5139 11.8354 4.98626 12.1608 4.66083Z",
    fill: "#141415"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83325 8.99642C4.83325 8.53618 5.20635 8.16309 5.66659 8.16309H16.4999C16.9602 8.16309 17.3333 8.53618 17.3333 8.99642C17.3333 9.45666 16.9602 9.82975 16.4999 9.82975H5.66659C5.20635 9.82975 4.83325 9.45666 4.83325 8.99642Z",
    fill: "#141415"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e44a5b465ebb92df00e5293f6fb8695b.svg";
export { ForwardRef as ReactComponent };